import normalise from './normalise';

const transform = (result) =>
    result.products.filter((product) => product.productId).map((product) => ({ ...product, id: product.productId }));

const concat = (acc, products) => [...acc, ...products];

const transformer = (results) => results.map(transform).reduce(concat, []);

export default (payload) => normalise(payload, transformer);
